import find from 'array.prototype.find';
import DrivesList from '../../Datafiles/DrivesList.json';
import { supportOldEpaWorkloads, updateVMWareOption } from './commonLogic';
import { said } from '../../AppConfig';
import { SizerIds, BLUE_DATA, SAPHANA } from '../constants/CommonConstants';
import * as Constants from '../constants/CommonConstants';
const initialState = {
  EULAPopUpState: true,
  activeSession: '',
  sessions: [],
  sessionDefaults: {
    workload: '',
    inputs: '',
    whatsNew: '',
    additionalInfo: '',
    Countries: '',
    blueDataWorkload: ''
  },
  notifications: null,
  responseMsg: [],
  userData: [],
  RABOM: '',
  Saveworkloadopened: false,
  sessionCount: 0,
  isLoading: false,
  LoadingMsg: '',
  feedback: {
    response: ''
  },
  Country: 'United States',
  overrideMsg: { isEnabled: false, msg: '' },
  overrideSolMsg: { isEnabled: false, msg: '' },
  notificationMsg: { isEnabled: false, msg: '' },
  showNotifications: { enabled: false },
  redirect: { isEnabled: false, path: '' },
  SSETid: undefined,
  SSETUrl: undefined,
  networkError: { isError: false, msg: '', ssetUrl: '' },
  ssetConfigurations: {
    reviewed: false
  }

  //CompareData:null
};

const defaultStorageNetworkSpeedObject = {
  "#text": "100G",
  "@isSelected": "no"
}
let driveList = DrivesList;
const EPA_WORKLOADTYPES = ["BigData", "BlueData"];
const tRUE_ = "true";
const fALSE_ = "false";
const NONE_ = "None";
const EPIC_ = "EPIC";
const GATEWAY = "Gateway";
const STORAGE = "Storage";
const MINIFI = "MiNifi"
const KUBERNETES_CM = "Kubernetes CM";
const GROWTH2YRole = '(Growth - 2Y)';
const GROWTH3YRole = '(Growth - 3Y)';
const GROWTH4YRole = '(Growth - 4Y)';

const epaLoadSolutionUpdates = (action) => {
  function createDataDiskArray(drive, workloadType) {
    let volumeName = "Persistent";
    if (workloadType === EPA_WORKLOADTYPES[0]) {
      volumeName = "Data_0"
    }
    let DataDiskArray = [
      {
        Item: {
          '@disk': drive.Item["@disk"],
          '@qty': drive.Item["@qty"],
          "@volumeName": volumeName
        }
      }
    ]
    return DataDiskArray;
  }
  function updateDriveDescription(role) {
    let index1 = driveList.BlueData.Server.findIndex(drive => (drive["Name"] === role["@Name"] && drive["OldDesc"] === role["@NodeDisk"]))
    if (index1 > -1) {
      role["@NodeDisk"] = driveList.BlueData.Server[index1]["NewDesc"];
    }
    if (role["@Type"] !== GATEWAY) {
      let index2 = driveList.BlueData.Server.findIndex(drive => (drive["Name"] === role["@Name"] && drive["OldDesc"] === role["@TStorageDrive"]))
      if (index2 > -1) {
        role["@TStorageDrive"] = driveList.BlueData.Server[index2]["NewDesc"];
      }
    }
    let index3 = driveList.BlueData.Server.findIndex(drive => (drive["Name"] === role["@Name"] && drive["OldDesc"] === role["@OSDisk"]))
    if (index3 > -1) {
      role["@OSDisk"] = driveList.BlueData.Server[index3]["NewDesc"];
    }
    if (role["@Type"] === STORAGE) {
      role.PersistentDisks.map(persistentDrive => {
        let index = driveList.BlueData.Server.findIndex(drive => (drive["Name"] === role["@Name"] && drive["OldDesc"] === persistentDrive.Item["@disk"]))
        if (index > -1) {
          persistentDrive.Item["@disk"] = driveList.BlueData.Server[index]["NewDesc"];
        }
      })
    }

  }
  function updateDriveDescriptionEPA(service) {
    let tagName = "@Server";
    if (service["@Type"] === MINIFI) {
      tagName = "@ServerName";
    }
    let index1 = driveList.BigData.Server.findIndex(drive => (drive["Name"] === service.Hardware[tagName] && drive["OldDesc"] === service.Hardware["@DataDisk"]));
    if (index1 > -1) {
      service.Hardware["@DataDisk"] = driveList.BigData.Server[index1]["NewDesc"];
    }
    let index2 = driveList.BigData.Server.findIndex(drive => (drive["Name"] === service.Hardware[tagName] && drive["OldDesc"] === service.Hardware["@OSDisk"]));
    if (index2 > -1) {
      service.Hardware["@OSDisk"] = driveList.BigData.Server[index2]["NewDesc"];
    }
    if (Array.isArray(service.DataDisks)) {
      service.DataDisks.map(dataDrive => {
        let index = driveList.BigData.Server.findIndex(drive => (drive["Name"] === service.Hardware[tagName] && drive["OldDesc"] === dataDrive.Item["@disk"]));
        if (index > -1) {
          dataDrive.Item["@disk"] = driveList.BigData.Server[index]["NewDesc"];
        }
      })
    }
  }
  if (action.payload.Workload.UserInputs.Country === undefined) {
    action.payload.Workload.UserInputs.Country = action.payload.Workload.UserInputs.Environments.Country;
  }
  if (action.payload.Workload.UserInputs.Environments.WorkloadType === EPA_WORKLOADTYPES[1]) {
    if (action.payload.Workload.UserInputs.Environments.isWLorSLLoaded === undefined) {
      action.payload.Workload.UserInputs.Environments.isWLorSLLoaded = tRUE_;
    }
    if (action.payload.Workload.UserInputs.Environments.displayNotePersistentDriveChange === undefined) {
      action.payload.Workload.UserInputs.Environments.displayNotePersistentDriveChange = fALSE_;
    }
    if (action.payload.Workload.UserInputs.Environments.ManagementHosts) {
      if (Array.isArray(action.payload.Workload.UserInputs.Environments.ManagementHosts.Server)) {
        updateVMWareOption(action.payload.Workload.UserInputs.Environments.ManagementHosts.Server);
      }
    }
    if (action.payload.Workload.UserInputs.Environments.Growth) {
      if (!Array.isArray(action.payload.Workload.UserInputs.Environments.Growth.Host)) {
        const oldGrowthObject = action.payload.Workload.UserInputs.Environments.Growth.Host;
        action.payload.Workload.UserInputs.Environments.Growth.Host = [];
        action.payload.Workload.UserInputs.Environments.Growth.Host.push(oldGrowthObject);
      }
    }
    if (action.payload.Workload.UserInputs.Environments.Templates && action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4]) {
      if (action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4]["@Type"] === "Storage") {
        if (action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4].PersistentDisks) {
          let persistentDrivesList = action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4].PersistentDisks
          if (!Array.isArray(persistentDrivesList)) {
            action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4].PersistentDisks = createDataDiskArray(persistentDrivesList, EPA_WORKLOADTYPES[1]);
          }
        }

      }
    }
    if (Array.isArray(action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
      if (action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.findIndex(license => license["@Type"] === KUBERNETES_CM) === -1) {
        let endIndex = action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.length;
        let IsSelected = tRUE_
        if (action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration['@Type'] === EPIC_) {
          IsSelected = fALSE_
        }
        action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[endIndex] = {
          "@Type": KUBERNETES_CM,
          "@IsSelected": IsSelected,
          "@Description": NONE_
        }
      }
    }
    if (action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed === undefined || (action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed && typeof (action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed) === "string")) {
      action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed = defaultStorageNetworkSpeedObject;
    }
    action.payload.Workload.UserInputs.Environments.Templates && action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server.map(role => {
      updateDriveDescription(role);
    })
  }
  if (action.payload.Workload.UserInputs.Environments.WorkloadType === EPA_WORKLOADTYPES[0]) {
    if (action.payload.Workload.UserInputs.Environments.Functions.Function) {
      action.payload.Workload.UserInputs.Environments.Functions.Function.map(Function => {
        if (Array.isArray(Function.Service)) {
          Function.Service.map(service => {
            if (service.DataDisks) {
              if (!(Array.isArray(service.DataDisks))) {
                service.DataDisks = createDataDiskArray(service.DataDisks, EPA_WORKLOADTYPES[0]);
              }
            }
            updateDriveDescriptionEPA(service);
          })
        } else {
          if (Function.Service.DataDisks) {
            if (!(Array.isArray(Function.Service.DataDisks))) {
              Function.Service.DataDisks = createDataDiskArray(Function.Service.DataDisks, EPA_WORKLOADTYPES[0]);
            }
          }
          updateDriveDescriptionEPA(Function.Service);
        }
      })
    }
    if (action.payload.TreeView && action.payload.TreeView.Solutions.Solution) {
      if (action.payload.TreeView.Solutions.Solution["@FirstRole"]) {
        if (action.payload.TreeView.Solutions.Solution["@FirstRole"].indexOf(Constants.HDFS_) > -1) {
          action.payload.TreeView.Solutions.Solution["@FirstRole"] = action.payload.TreeView.Solutions.Solution["@FirstRole"].replace(Constants.HDFS_, Constants.DATA_LAKE);
        }
      }
      if (action.payload.TreeView.Solutions.Solution.Roles) {
        if (action.payload.TreeView.Solutions.Solution.Roles["@FirstRole"].indexOf(Constants.HDFS_) > -1) {
          action.payload.TreeView.Solutions.Solution.Roles["@FirstRole"] = action.payload.TreeView.Solutions.Solution.Roles["@FirstRole"].replace(Constants.HDFS_, Constants.DATA_LAKE);
        }
        if (Array.isArray(action.payload.TreeView.Solutions.Solution.Roles.Role)) {
          action.payload.TreeView.Solutions.Solution.Roles.Role.map(role => {
            if (role[Constants.ROLENAME_]) {
              if (role[Constants.ROLENAME_].indexOf(Constants.HDFS_) > -1) {
                role[Constants.ROLENAME_] = role[Constants.ROLENAME_].replace(Constants.HDFS_, Constants.DATA_LAKE);
              }
            }
          })
        }
      }
    }
  }
  return action
}
const sessionsReducer = (state = initialState, action) => {

  var allNotifications;
  var actvSession;
  switch (action.type) {

    case 'ADD_SESSION':

      //var currtime = new Date();
      // var newAlias = currtime.getMilliseconds();
      var newAlias = state.sessionCount + 1;
      let newSession = {};

      if (action.payload.name.indexOf('Default Session') !== 0) {
        newSession = {
          id: action.payload.id,
          alias: action.payload.name,
          workload: '',
          treeView: '',
          bomView: '',
          configView: '',
          GRInput: '',
          GRBomInput: '',
          MetricsData: '',
          CompareMetricsData: '',
          CompareSolution: '',
          MultipleSolActiveTab: '',
          isSizeEnabled: false,
          globalError: { isError: false, errorMsg: '' },
          EPAArray: [],
          sizingFailed: '',
          NonGPUValue: {
            TotalVMemory: '',
            TotalCore: '',
            TotalStorage: '',
            Server: '',
            Proc: '',
            Memory: '',
            Drive: '',
            DriveQty: '',
            ServerQty: ''
          },
          GPUValue: {
            TotalVMemory: '',
            TotalCore: '1',
            TotalStorage: '',
            Server: '',
            Proc: '',
            Memory: '',
            Drive: '',
            DriveQty: '',
            ServerQty: ''
          },
          CompareData: null,
          SavedSolname: null,
          strmessage: null,
          FirstClik: { val: true }
          //title:{value:"HDFS and HDFS-EC"}
        };
      } else {
        newSession = {
          id: action.payload.id,
          alias: action.payload.name + ' (' + newAlias + ') ',
          workload: '',
          treeView: '',
          bomView: '',
          configView: '',
          GRInput: '',
          GRBomInput: '',
          MetricsData: '',
          CompareMetricsData: '',
          CompareSolution: '',
          MultipleSolActiveTab: '',
          isSizeEnabled: false,
          globalError: { isError: false, errorMsg: '' },
          EPAArray: [],
          sizingFailed: '',
          NonGPUValue: {
            TotalVMemory: '',
            TotalCore: '',
            TotalStorage: '',
            Server: '',
            Proc: '',
            Memory: '',
            Drive: '',
            DriveQty: '',
            ServerQty: ''
          },
          GPUValue: {
            TotalVMemory: '',
            TotalCore: '',
            TotalStorage: '',
            Server: '',
            Proc: '',
            Memory: '',
            Drive: '',
            DriveQty: '',
            ServerQty: ''
          },
          CompareData: null,
          SavedSolname: null,
          strmessage: null,
          FirstClik: { val: true }
          //title:{value:"HDFS and HDFS-EC"}  
        };
      }

      return Object.assign({}, state, {
        activeSession: newSession,
        sessions: state.sessions.concat(newSession),
        sessionCount: newAlias
      });

    case 'CHANGE_SESSION':

      return Object.assign({}, state, {
        activeSession: find(state.sessions, function (value) {
          if (value.id === action.payload.id)
            return value;
        })
      });

    case 'COUNTRY_CHANGE':
      return Object.assign({}, state, {
        Country: action.payload.country
      });

    case 'UPDATE_SESSION':
      return Object.assign({}, state, {
        sessions: state.sessions.map((item) => item.id !== action.payload.session.id ? item : Object.assign({}, item, { alias: action.payload.session.alias }))
      });

    case 'SAVE_DATA':

      return Object.assign({}, state, {
        sessions: state.sessions.map((item) => item.id !== state.activeSession.id ? item : JSON.parse(JSON.stringify(state.activeSession)))
      });
    case 'OPENED_SAVEWORKLOAD':
      return Object.assign({}, state, {
        Saveworkloadopened: action.payload.data
      });
    case 'DELETE_SESSION':
      return Object.assign({}, state, {
        sessions: state.sessions.filter((value, index) => {
          if (value.id !== action.payload.id)
            return value;
        }),
        activeSession: {
          ...state.activeSession,
          id: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.id,
          alias: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.alias,
          workload: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.workload,
          treeView: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.treeView,
          bomView: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.bomView,
          configView: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.configView,
          GRInput: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.GRInput,
          GRBomInput: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.GRBomInput,
          MetricsData: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.MetricsData,
          CompareMetricsData: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.CompareMetricsData,
          CompareSolution: (action.payload.id === state.activeSession.id) ? '' : state.activeSession.CompareSolution,
        }
      });

    case 'ERROR_SESSION':
      // return Object.assign({}, state, {
      //   globalError: action.payload.errorMsg
      // });

      //  return Object.assign({}, state, {
      //      sessions : state.sessions.map((item) => item.id !== state.activeSession.id ? item : Object.assign({}, item, { globalError: action.payload.errorMsg }))
      //  });
      return {
        ...state,
        activeSession: { ...state.activeSession, globalError: action.payload.errorMsg }
      }

    case 'TOGGLE_SIZE_BUTTON':
      return {
        ...state,
        activeSession: { ...state.activeSession, isSizeEnabled: action.payload.value }
      }

    case 'EPA_ACTV_SOLN_CHANGE':

      let prevItem = Object.assign([], state.activeSession.EPAArray);

      let newEPAarr = [];

      let currentItem = prevItem.find(item => item.treeView.Solutions.Solution.SolProfile['@ID'] === state.activeSession.treeView.Solutions.Solution.SolProfile["@ID"])
      currentItem.treeView = state.activeSession.treeView;
      currentItem.bomView = state.activeSession.bomView;
      currentItem.configView = state.activeSession.configView;
      currentItem.GRInput = state.activeSession.GRInput;
      currentItem.GRBomInput = state.activeSession.GRBomInput;

      newEPAarr = prevItem;

      let newitem = prevItem.find(item => item.treeView.Solutions.Solution.SolProfile['@ID'] === action.payload.data.actvItem.toString())

      return {
        ...state,
        activeSession: {
          ...state.activeSession,
          EPAArray: newEPAarr,
          treeView: newitem.treeView,
          bomView: newitem.bomView,
          configView: newitem.configView,
          GRInput: newitem.GRInput,
          GRBomInput: newitem.GRBomInput
        }
      }

    case 'FETCH_RA_BOM_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the RA BOM data.'
      });

    case 'DOWNLOAD_FILE_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while downloading...'
      });

    case 'DOWNLOAD_FILE_SUCCESS':
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: ''
      });

    case 'FETCH_RA_BOM_SUCCESS':
      return {
        ...state,
        RABOM: action.payload,
        isLoading: false,
        LoadingMsg: ''
      };

    case 'FETCH_DEFAULT_DATA_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while Initializing...'
      });


    case 'LOAD_NOTIFICATIONS_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while checking for Notifications.'
      });


    case 'LOAD_NOTIFICATIONS_SUCCESS':
      return {
        ...state,
        notifications: action.payload,
        isLoading: false,
        LoadingMsg: ''
      };



    case 'REJECT_WLSL_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while Removing workload/solution.'
      });

    case 'REJECT_WLSL_SUCCESS':
      allNotifications = state.notifications;
      for (let j = 0; j < action.payload.length; j++) {
        for (let i = 0; i < allNotifications.length; i++) {
          if (allNotifications[i].itemID === action.payload[j].itemID) {
            allNotifications.splice(i, 1);
          }
        }
      }
      return Object.assign({}, state, {
        responseMsg: action.payload,
        notifications: allNotifications,
        isLoading: false,
        LoadingMsg: ''
      });

    case 'ACCEPT_WLSL_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while adding workload/solution.'
      });

    case 'ACCEPT_WLSL_SUCCESS':
      allNotifications = state.notifications;
      for (let j = 0; j < action.payload.length; j++) {
        for (let i = 0; i < allNotifications.length; i++) {
          if (allNotifications[i].itemID === action.payload[j].itemID) {
            allNotifications.splice(i, 1);
          }
        }
      }
      return Object.assign({}, state, {
        responseMsg: action.payload,
        notifications: allNotifications,
        isLoading: false,
        LoadingMsg: ''
      });

    case 'FETCH_DEFAULT_DATA_SUCCESS':
      var bluedataWorkloadtemp = undefined;
      var whatsNewHPECPTag;
      let tdiWorkload;
      if (action.payload.BlueDataDefaults !== undefined) {
        bluedataWorkloadtemp = action.payload.BlueDataDefaults.Workload
      }
      if (action.payload.whatsNewHPECP !== undefined) {
        whatsNewHPECPTag = action.payload.whatsNewHPECP;
      }
      if (action.payload.tdiWorkload) {
       
        // action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ProductionEnvironment.ProcessorFamily.Item = action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ProductionEnvironment.ProcessorFamily.Item.filter((x)=> x==="CascadeLake");
        // action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ApplicationEnvironment.ProcessorFamily.Item = action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ApplicationEnvironment.ProcessorFamily.Item.filter((x)=>x==="CascadeLake");

        tdiWorkload = action.payload.tdiWorkload.WorkLoad;
        
      }

      return Object.assign({}, state, {
        sessionDefaults: { workload: action.payload.workload.Workload, inputs: action.payload.input, whatsNew: action.payload.whatsNew, whatsNewHPECP: whatsNewHPECPTag, additionalInfo: action.payload.additionalInfo, Countries: action.payload.Countries, blueDataWorkload: bluedataWorkloadtemp, tdiWorkload: tdiWorkload },
        isLoading: false,
        LoadingMsg: ''
      });

    case 'FETCH_METRICS_DATA_PENDING':
      return Object.assign({}, state, {
        isLoadingCompare: true,
        LoadingMsgCompare: 'Please wait while fetching the Metrics data.'
      });

    case 'FETCH_METRICS_DATA_SUCCESS':

      actvSession = state.activeSession;
      if (actvSession === "") {
        actvSession = {};
      }
      actvSession.MetricsData = { output: action.payload.output, manipulationData: action.payload.addRemoveContent };

      return {
        ...state,
        activeSession: actvSession,
        isLoadingCompare: false,
        LoadingMsgCompare: ''
      }

    case 'FETCH_COMPARE_METRICS_DATA_PENDING':
      return Object.assign({}, state, {
        isLoadingCompare: true,
        LoadingMsgCompare: 'Please wait while fetching the Compare Metrics data.'
      });

    case 'FETCH_COMPARE_METRICS_DATA_SUCCESS':

      actvSession = state.activeSession;
      actvSession.CompareMetricsData = action.payload;
      return {
        ...state,
        activeSession: actvSession,
        isLoadingCompare: false,
        LoadingMsgCompare: ''
      }
    case 'CLEAR_COMPARE_METRICS':
      actvSession = state.activeSession;
      actvSession.CompareMetricsData = '';
      return {
        ...state,
        activeSession: actvSession,
      }

    case 'FETCH_COMPARE_SOLUTION_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the Compare Solution data.'
      });

    case 'FETCH_COMPARE_SOLUTION_SUCCESS':

      actvSession = state.activeSession;
      actvSession.CompareSolution = action.payload;
      return {
        ...state,
        activeSession: actvSession,
        isLoading: false,
        LoadingMsg: ''
      }

    case 'FETCH_SOLUTION_ERROR':
      actvSession = state.activeSession;
      actvSession.sizingFailed = action.payload;
      return Object.assign({}, state, {
        ...state,
        activeSession: actvSession,
        isLoading: false,
        LoadingMsg: ' ',
      });


    case 'FETCH_SOLUTION_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while Sizing the Solution.'
      });

    case 'FETCH_SOLUTION_ADVANCED_PENDING':
      let msg = 'Please wait while Sizing the Solution.'
      if (action.payload !== undefined && action.payload.isSizerAsEntry) {
        msg = 'Please wait while we create guidance.'
      }
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: msg
      });

    case 'FETCH_SOLUTION_ADVANCED_ERROR':

      let message = action.payload.statusMessage === "User authenticated anonymously." ? "You need “SSET - User Access” to continue." : action.payload.statusMessage

      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: ' ',
        networkError: {
          isError: true,
          msg: message,
          ssetUrl: action.payload.url
        }
      });

    case 'CLEAR_GUIDANCE_ERROR':
      return Object.assign({}, state, {
        networkError: {
          isError: false,
          msg: '',
          ssetUrl: ''
        }
      });


    case 'POSTSSET_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: action.payload
      });

    case 'POSTSSET_SUCCESS':
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        SSETUrl: action.payload
      });

    case 'FETCH_SOLUTION_SUCCESS':

      actvSession = state.activeSession;
      actvSession.sizingFailed = '';
      actvSession.treeView = action.payload;
      //dj  included below line to clear the current 2 solutions.
      actvSession.EPAArray = [];
      return {
        ...state,
        activeSession: actvSession,
        sessions: state.sessions.map((item) => item.id !== state.activeSession.id ? item : Object.assign({}, actvSession)),
        isLoading: false,
        LoadingMsg: ''
      }

    //     return Object.assign({}, state, {
    //       activeSession : Object.assign({}, state.activeSession, { treeView: action.payload }),
    //       // sessions: 
    //       isLoading:false,
    //       LoadingMsg: ''
    // });

    case 'FETCH_BOM_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the Bill of material.'
      });

    case 'FETCH_BOM_SUCCESS':
      return {
        ...state,
        activeSession: { ...state.activeSession, bomView: action.payload },
        isLoading: false,
        LoadingMsg: ''
      }

    case 'FETCH_CONFIGDETAILS_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the Configuration details.'
      });

    case 'FETCH_CONFIGDETAILS_SUCCESS':
      return {
        ...state,
        activeSession: { ...state.activeSession, configView: action.payload },
        isLoading: false,
        LoadingMsg: ''
      }

    case 'FETCH_GR_INPUT_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the Configuration details.'
      });

    case 'FETCH_GR_INPUT_SUCCESS':
      return {
        ...state,
        activeSession: { ...state.activeSession, GRInput: action.payload.GraphicalInputs },
        isLoading: false,
        LoadingMsg: ''
      }

    case 'FETCH_GRBOM_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the Configuration details.'
      });

    case 'FETCH_GRBOM_SUCCESS':

      return {
        ...state,
        activeSession: { ...state.activeSession, GRBomInput: action.payload.Solution },
        isLoading: false,
        LoadingMsg: ''
      }

    case 'SAVE_WORKLOAD_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while saving the current workload into the database.'
      });

    case 'SAVE_WORKLOAD_SUCCESS':

      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        overrideMsg: { isEnabled: false, msg: '' },
        notificationMsg: { isEnabled: true, msg: action.payload }
      });

    case 'REDIRECT_CONFLICT':
      return Object.assign({}, state, {
        redirect: { isEnabled: action.payload.isTrue, path: action.payload.path }
      });

    case 'WORKLOAD_CONFLICT':
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        overrideMsg: { isEnabled: true, msg: 'The Workload with this name already exists in the database. Would you like to replace it?' }
      });

    case 'SOLUTION_CONFLICT':
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        overrideSolMsg: { isEnabled: true, msg: 'The Solution with this name already exists in the database. Would you like to replace it?' }
      });

    case 'DISMISS_CONFLICTS':
      {
        return Object.assign({}, state, {
          overrideMsg: { isEnabled: false, msg: '' },
          overrideSolMsg: { isEnabled: false, msg: '' }
        });
      }

    case 'DISMISS_TOAST':
      {
        return Object.assign({}, state, {
          notificationMsg: { isEnabled: false, msg: '' }
        });
      }

    case 'UPDATE_SSETID':
      {
        return Object.assign({}, state, {
          SSETid: action.payload
        });
      }

    case 'SAVE_SOLUTION_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while saving the current solution into the database.'
      });

    case 'SAVE_SOLUTION_SUCCESS':

      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        overrideSolMsg: { isEnabled: false, msg: '' },
        notificationMsg: { isEnabled: true, msg: action.payload }
      });

    case 'LOAD_USER_DATA_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the data from database.'
      });

    case 'LOAD_USER_DATA_SUCCESS':

      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        userData: action.payload
      });
    case 'DELETE_SELECTION_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while Deleting the user selection.',

      });

    case 'DELETE_SELECTION_SUCCESS':

      var userdatatemp = []
      userdatatemp = state.userData
      var result = []
      userdatatemp.filter((val, id) => {
        if (val.id === parseInt(action.payload, 10)) {
          userdatatemp.splice(id, 1);
        }
      })
      result = userdatatemp
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        userData: result,
      });

    case 'LOAD_SELECTION_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while loading the user selection.'
      });

    case 'UPDATE_Active_WORKLOAD':
      return Object.assign({}, state, {
        activeSession: {
          ...state.activeSession,
          workload: action.payload,
        }
      });

    case 'LOAD_SELECTION_SUCCESS':

      var atvSess = {
        id: '',
        alias: '',
        workload: JSON.parse(JSON.stringify(state.sessionDefaults.workload)),
        treeView: '',
        bomView: '',
        configView: '',
        GRInput: '',
        GRBomInput: '',
        MetricsData: '',
        CompareMetricsData: '',
        CompareSolution: '',
        globalError: { isError: false, errorMsg: '' },
        isSizeEnabled: false,
        EPAArray: [],
        NonGPUValue: {
          TotalVMemory: '',
          TotalCore: '',
          TotalStorage: '',
          Server: '',
          Proc: '',
          Memory: '',
          Drive: '',
          DriveQty: '',
          ServerQty: ''
        },
        GPUValue: {
          TotalVMemory: '',
          TotalCore: '',
          TotalStorage: '',
          Server: '',
          Proc: '',
          Memory: '',
          Drive: '',
          DriveQty: '',
          ServerQty: ''
        },
        strmessage: null,
        FirstClik: { val: true }
        // isSizeEnabled: true,
      };
      if (atvSess.workload === "") {
        atvSess.workload = {
          UserInputs: ''
        }
      }

      if (action.payload.Workload.UserInputs.Environments) {
        if (EPA_WORKLOADTYPES.indexOf(action.payload.Workload.UserInputs.Environments.WorkloadType) > -1) {
          action = epaLoadSolutionUpdates(action);
        }
      }
      if(said === SizerIds.SAPHANA && action.payload.Workload.UserInputs.Environments.WorkloadType===undefined && action.payload.Workload.UserInputs.Environments.WorkLoadType!==undefined){
        action.payload.Workload.UserInputs.Environments.WorkloadType = action.payload.Workload.UserInputs.Environments.WorkLoadType;
      }

      if (said === SizerIds.EPAVNEXT && action.payload.Workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
        atvSess.workload.UserInputs = supportOldEpaWorkloads(state.sessionDefaults.blueDataWorkload, action.payload.Workload).UserInputs;
      } else if (said === SizerIds.SAPHANA && (!action.payload.Workload.UserInputs.Environments.WorkloadType || (action.payload.Workload.UserInputs.Environments.WorkloadType === SAPHANA))) {
        if ((!action.payload.Workload.UserInputs.Environments.WorkloadType || (action.payload.Workload.UserInputs.Environments.WorkloadType && action.payload.Workload.UserInputs.Environments.WorkloadType === "SAPHANA")) && !action.payload.Workload.UserInputs.Environments.ApplicationEnvironment) {
          state.sessionDefaults.workload.UserInputs.Environments.CustomerInfo = action.payload.Workload.UserInputs.Environments.CustomerInfo;
          state.sessionDefaults.workload.UserInputs.Environments.ProductionEnvironment.DataBaseSize = action.payload.Workload.UserInputs.Environments.ProductionEnvironment.DataBaseSize;
          state.sessionDefaults.workload.UserInputs.Environments.ProductionEnvironment.GrowthYears = action.payload.Workload.UserInputs.Environments.ProductionEnvironment.GrowthYears;
          state.sessionDefaults.workload.UserInputs.Environments.ProductionEnvironment.YearlyGrowth = action.payload.Workload.UserInputs.Environments.ProductionEnvironment.YearlyGrowth;
          atvSess.workload.UserInputs = JSON.parse(JSON.stringify(state.sessionDefaults.workload.UserInputs));
          atvSess.workload.UserInputs.Environments.isOldWorkload = true;
        }
        else {
          atvSess.workload.UserInputs = action.payload.Workload.UserInputs;
        }
      } else {
        atvSess.workload.UserInputs = action.payload.Workload.UserInputs;
      }
      atvSess.id = action.payload.SessionID;
      atvSess.alias = action.payload.Alias;

      if (action.payload.EPAArray !== undefined && action.payload.EPAArray.length > 0) {
        atvSess.EPAArray = action.payload.EPAArray;
      }


      if (action.payload.TreeView === null || state.SSETid !== undefined) {
        atvSess.treeView = "";
      } else {
        atvSess.treeView = action.payload.TreeView;
      }
      var SessionAvailable = 0;

      state.sessions.forEach(function (item) {
        if (item.alias.toString().indexOf(atvSess.alias) >= 0) {
          SessionAvailable++;
        }
      });

      if (SessionAvailable > 0) {

        atvSess.alias = atvSess.alias + ' (' + SessionAvailable + ')';

        return Object.assign({}, state, {
          //  sessions: state.sessions.map((item) => item.id !== atvSess.id ? item : Object.assign(atvSess)),
          sessions: state.sessions.concat(atvSess),
          activeSession: atvSess,
          isLoading: false,
          LoadingMsg: '',
        });
      } else {
        return Object.assign({}, state, {
          // sessions:state.sessions.map((item) => item.id !== state.activeSession.id ? item : Object.assign(atvSess)),
          sessions: state.sessions.concat(atvSess),
          activeSession: atvSess,
          isLoading: false,
          LoadingMsg: '',
        });
      }

    case 'UPDATE_LOADED_OLD_SOLUTION':
      return Object.assign({}, state, {
        loadedOldSolution: action.payload
      })
    case 'SERVER_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
        isLoginPending: false,
        LoginMsg: '',
        //  notificationMsg:{isEnabled:true,msg:'Something Went wrong...',isError:true}

      });
    case 'CLOSE_EULA':

      return Object.assign({}, state, {
        EULAPopUpState: action.payload.data
      });
    case 'LOGIN_PENDING': {
      return Object.assign({}, state, {
        isLoginPending: true,
        LoginMsg: 'Please wait while signing in.'
      });
    }
    case 'LOGIN_SUCCESS': {
      return Object.assign({}, state, {
        isLoginPending: false,
        LoginMsg: '',
      });
    }
    case 'LOGOUT_PENDING': {
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while logging out.'
      });
    }
    case 'LOGOUT_SUCCESS': {
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
      });
    }

    case 'OSLISTBLUEDATA_SUCCESS': {
      return Object.assign({}, state, {
        isLoading: false,
        LoadingMsg: '',
      });
    }

    case 'SHARE_SELECTION_SUCCESS':
      return {
        ...state,
        feedback: { ...state.feedback, response: action.payload }
      }

    case 'CALCULATEBLUEDATACONFIG_SUCCESS':
      var type = ''
      // var workloadtemp = '';
      var GPUvaluetemp = '';
      var NonGPUvaluetemp = '';
      //  var Errormsgtemp=''
      //  var isErrortemp=''
      //state.workload.UserInputs.Environments.Templates.ServerDetails.Server.filter((val) => {
      for (let key in action.payload) {
        if (key === "NonGPU_Result") {
          type = "NonGPU"
          state.activeSession.NonGPUValue.TotalVMemory = action.payload[key]['d_TotalVMemory']
          state.activeSession.NonGPUValue.TotalCore = action.payload[key]['d_TotalVCPU']
          state.activeSession.NonGPUValue.TotalStorage = action.payload[key]['d_TotalStorage']
        } else if (key === "GPU_Result") {
          type = "GPU"
          state.activeSession.GPUValue.TotalVMemory = action.payload[key]['d_TotalVMemory']
          state.activeSession.GPUValue.TotalCore = action.payload[key]['d_TotalVCPU']
          state.activeSession.GPUValue.TotalStorage = action.payload[key]['d_TotalStorage']
        }

        //if (val['@Type'] === type) {
        if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
          //  isErrortemp=false
          if (action.payload[key]['RecommendedServer'] !== null) {
            if (type === "NonGPU") {
              state.activeSession.NonGPUValue.Drive = action.payload[key]['RecommendedDriveDesc']
              state.activeSession.NonGPUValue.DriveQty = action.payload[key]['RecommendedDriveQty']
              state.activeSession.NonGPUValue.Memory = action.payload[key]['RecommendedMemory']
              state.activeSession.NonGPUValue.Proc = action.payload[key]['RecommendedProc']
              state.activeSession.NonGPUValue.Server = action.payload[key]['RecommendedServer']
              state.activeSession.NonGPUValue.ServerQty = action.payload[key]['d_ServerQty']
            }
            if (type === "GPU") {
              state.activeSession.GPUValue.Drive = action.payload[key]['RecommendedDriveDesc']
              state.activeSession.GPUValue.DriveQty = action.payload[key]['RecommendedDriveQty']
              state.activeSession.GPUValue.Memory = action.payload[key]['RecommendedMemory']
              state.activeSession.GPUValue.Proc = action.payload[key]['RecommendedProc']
              state.activeSession.GPUValue.Server = action.payload[key]['RecommendedServer']
              state.activeSession.GPUValue.ServerQty = action.payload[key]['d_ServerQty']
            }
          }
        }
        else {
          //  Errormsgtemp=action.payload[key]['ErrorMsg'];
          //  isErrortemp=true
        }
        // }
      }
      // });
      //  workloadtemp = state.workload
      GPUvaluetemp = state.activeSession.GPUValue
      NonGPUvaluetemp = state.activeSession.NonGPUValue
      // let caltemprst=true
      // let caltempcount=state.count-1
      //  if(state.count-1===0)
      //  {
      //   caltemprst=false
      // }
      return Object.assign({}, state, {
        // workload: workloadtemp,
        activeSession: { ...state.activeSession, GPUValue: GPUvaluetemp, NonGPUValue: NonGPUvaluetemp },
        // GPUValue:GPUvaluetemp,
        // NonGPUValue:NonGPUvaluetemp,
        // BlueDataCal: action.payload,
        isLoading: false,
        //  isCal: caltemprst,
        // count:caltempcount,
        // Errormsg:Errormsgtemp,
        //isError:isErrortemp
      });
    //  case 'FETCH_NODEQTY_SUCCESS':
    //   return Object.assign({}, state, {
    //          activeSession : {...state.activeSession, strmessage:action.payload.strmessage},
    //       });
    case 'EPA_MULTIPLE_SOLUTIONS_SUCCESS':
      actvSession = state.activeSession;
      actvSession.treeView = action.payload.data;
      actvSession.EPAArray = action.payload.multipleSolutions;
      return Object.assign({}, state, {
        ...state,
        activeSession: actvSession,
        sessions: state.sessions.map((item) => item.id !== state.activeSession.id ? item : Object.assign({}, actvSession)),
        isLoading: false,
        LoadingMsg: ''
      });
    /*  case 'CALCULATEBLUEDATACONFIG_SUCCESS':
          var errmsg={
            isError:false,
            errorMsg:''
          }
            for (let key in action.payload) {
          if(action.payload[key]['d_ServerQty'] === 'Infinity')
          {
          errmsg={
                  isError:true, errorMsg:'Increase Drive Size. If drive size is larger than node storage will not fit on this server '
                }
          }
            }
          return{
              ...state,
              activeSession : {...state.activeSession, globalError:errmsg}
          }
         case 'COMPARE_SOL_DATA_PENDING':
           return Object.assign({}, state, {
             ...state,
               isLoading: true,
               LoadingMsg: 'Please wait while comparing data'   
       });
    */

    case 'SAP_SOL_PREVIEW_SUCCESS':
      return Object.assign({}, state, {
        SAPSolPreview: JSON.parse(JSON.stringify(action.payload)),
        isLoading: false
      });
    case 'SAP_SOL_PREVIEW_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the data.'
      });
    case 'SAP_SOL_PREVIEW_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
      });
    case 'SAPHANA_SOL_PREVIEW_SUCCESS':
      return Object.assign({}, state, {
        SAPHANASolPreview: JSON.parse(JSON.stringify(action.payload)),
        isLoading: false
      });
    case 'SAPHANA_SOL_PREVIEW_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the data.'
      });
    case 'SAPHANA_SOL_PREVIEW_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
      });

    case 'SAPTDI_SOL_PREVIEW_SUCCESS':
      return Object.assign({}, state, {
        SAPTDISolPreview: JSON.parse(JSON.stringify(action.payload)),
        isLoading: false
      });
    case 'SAPTDI_SOL_PREVIEW_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching the data.'
      });
    case 'SAPTDI_SOL_PREVIEW_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
      });

    case 'COMPARE_SOL_DATA_SUCCESS':
      if (action.payload !== "File Mismatch" && action.payload !== "Different Pricing Region") {
        let actvSession = state.activeSession;
        for (let i = 0; i < 2; i++) {
          action.payload.Solutions.Solution[i]['@FirstRole'] = action.payload.Solutions.Solution[i]['@FirstRole'].replace(GROWTH2YRole, '').replace(GROWTH3YRole, '').replace(GROWTH4YRole, '').trim();
          action.payload.Solutions.Solution[i]['Roles']['@FirstRole'] = action.payload.Solutions.Solution[i]['Roles']['@FirstRole'].replace(GROWTH2YRole, '').replace(GROWTH3YRole, '').replace(GROWTH4YRole, '').trim();
          action.payload.Solutions.Solution[i].Roles.Role.map(item => {
            item.RoleName = item.RoleName.replace(GROWTH2YRole, '').replace(GROWTH3YRole, '').replace(GROWTH4YRole, '').trim();
          })
        }

        actvSession.CompareData = { CompareData: action.payload.Solutions }
        return {
          ...state,
          isLoading: false,
          LoadingMsg: '',
          activeSession: actvSession
          // CompareData : {CompareData:action.payload.Solutions}
        }
      } else {
        let actvSession = state.activeSession;
        actvSession.CompareData = { CompareData: action.payload };
        return {
          ...state,
          isLoading: false,
          LoadingMsg: '',
          activeSession: actvSession
          //CompareData : {CompareData:action.payload}
        }
      }

    case 'COMPARE_GLGROWTH_DATA_SUCCESS':

      state.activeSession = action.payload;
      return {
        ...state,
        //CompareData : {CompareData:action.payload}
      }

    case 'CLEAR_COMPARE_DATA':
      actvSession = state.activeSession;
      actvSession.CompareData = { CompareData: null };
      return {
        // ...state,
        // CompareData : null
        ...state,
        activeSession: actvSession
      }
    case 'SAVEDSOL_NAME':
      let actvSessionsave = state.activeSession;
      actvSessionsave.SavedSolname = { SavedSol: action.payload.SavedSolutionName, savedId: action.payload.selectedselection };
      return {
        // ...state,
        // CompareData : null
        ...state,
        activeSession: actvSessionsave
      }
    //     case "SELECTED_SERVICE_VALUE":
    //      let actvSessionservice = state.activeSession;
    //     actvSessionservice.title = action.payload
    //  return{
    //          ...state,
    //          activeSession:actvSessionservice
    //     }
  }
  return state;
};

export default sessionsReducer;



// WEBPACK FOOTER //
// ./src/State/reducers/sessions.js